<template>
  <div>
    <aw-product-list-page v-if="isCategory" />
    <aw-content-seo-text
      v-if="getCategoryFromTree && getCategoryFromTree.seoTextId"
      :content-id="getCategoryFromTree.seoTextId"
      :class="$style.seoTextContent"
    />
  </div>
</template>

<script>
  import { defineAsyncComponent } from 'vue';
  import { mapState } from 'pinia';
  import AwProductListPage from '~~/common/components/Page/ProductList/AwProductListPage';

  import { useUrlResourceStore } from '~~/common/stores/urlResource';
  import { useCategoryStore } from '~~/common/stores/category';
  import { useProductsStore } from '~~/common/stores/products';

  export default {
    name: 'ProductListPage',
    components: {
      AwProductListPage,
      AwContentSeoText: defineAsyncComponent(() => import('~~/shop/components/AwContentSeoText')),
    },
    computed: {
      ...mapState(useCategoryStore, {
        getCategoryFromTree: state => state.getCategoryFromTree,
      }),
      promotionRecommendationCarouselId () {
        return this.getCategoryFromTree?.promotionRecommendationCarouselId;
      },
      ...mapState(useUrlResourceStore, {
        isCategory (state) {
          return state.data.resourceType === 'category' || state.data.resourceType === 'boutique';
        },
      }),
      ...mapState(useProductsStore, {
        itemsPerPage: state => state.itemsPerPage,
        sortKey: state => state.sortKey,
        sortBy: state => state.sortBy,
        filterBy: state => state.filterBy,
        itemCount: state => state.itemCount,
        products: state => state.products,
      }),
    },
  };
</script>


<style module lang="scss" rel="stylesheet/scss">
.seoTextContent {
  margin-top: 30px;
}
</style>


